var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mt-10 pt-10"},[_c('v-row',[_c('v-col',{attrs:{"cols":"2"}},[_c('report-list',{attrs:{"reportList":_vm.reportList,"selectedReport":_vm.selectedReport,"selectReport":_vm.selectReport}})],1),_c('v-col',[_c('viewer',{attrs:{"reportName":_vm.selectedReport}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }